<div class="checkbox-list">
  <div *ngFor="let user of users" class="checkbox-item">
    <p-checkbox
      name="updateInvited"
      [value]="user"
      [(ngModel)]="selectedUsers"
      (onChange)="onChange.emit(selectedUsers)"
      [inputId]="user.id + '__' + user.inherited"
      [disabled]="(disabled || user.inherited)"
    ></p-checkbox>
    <bulb-unit-chip
      class="mock-label"
      [ngClass]="{'mock-label--disabled': (disabled || user.inherited)}"
      [unit]="user"
    ></bulb-unit-chip>
  </div>
</div>
